import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-placeholder',
  templateUrl: './content-placeholder.component.html',
  styleUrls: ['./content-placeholder.component.scss'],
  host: {
    '[class.hide]': "!visible",
    '[class.loaded]': "state == 'loaded' || state == 'rendered'",
    '[class.loading]': "state == 'loading'",
    '[class.refreshing]': "state == 'refreshing'",
    '[class.unavailable]': "state == 'unavailable'",
    '[class.error]': "state == 'error'",
    '[class.drop-shadow]': "dropShadow",
  },
  standalone: false
})
export class ContentPlaceholderComponent {
  @Input() visible = true;
  @Input() state: ContentLoadState = ContentLoadState.Loading;
  @Input() loadingItemText: string = 'content';
  @Input() itemText: string = 'content';
  @Input() dropShadow = true; 
  @Input() loadingSubText: string = null;
  @Input() refreshingSubText: string = null;
};

// TODO: Move this enum to a common file
export enum ContentLoadState {
  Loading = 'loading',
  Refreshing = 'refreshing',
  Loaded = 'loaded',
  Rendered = 'rendered',
  Unavailable = 'unavailable',
  Deleted = 'deleted',
  Error = 'error'
};
